<template>
  <div class="home">
    <vue-headful
      title="Feed | GI Updates"
      description="See all the latest content from Gaming Illuminaughty creators."
    />
    <BaseHero>
      <div class="hero-body">
        <h1 class="title">GIUPDATES.TV</h1>
        <h2 class="subtitle">For all things Gaming Illuminaughty</h2>
      </div>
    </BaseHero>
    <section class="content-wrapper">
      <div class="container offset">
        <div v-if="twitchAPIResponses.length > 0" class="columns is-gapless">
          <div class="column is-8 twitch-player-wrapper">
            <vue-twitch-player
              id="twitch-player"
              width="100%"
              height="503px"
              class="test"
              :channel="channel"
            ></vue-twitch-player>
          </div>
          <div class="column is-4 streams">
            <twitch-chat
              :channel="channel"
              width="100%"
              height="503"
            ></twitch-chat>
          </div>
        </div>
        <div class="twitch-feed gi-card">
          <b-loading
            :is-full-page="false"
            v-model="twitchLoading"
            :can-cancel="true"
          ></b-loading>

          <h1 class="title">
            <i class="fab fa-twitch" style="margin-right: 1rem"></i>Watch GI
            Live on Twitch
          </h1>
          <transition name="list">
            <div
              v-if="twitchAPIResponses.length > 0"
              class="columns is-multiline"
            >
              <div
                v-for="creator in twitchAPIResponses"
                :key="creator.id"
                class="column is-3"
                data-aos="fade-in"
              >
                <div class="card video-item">
                  <div class="card-image">
                    <figure class="image is-16by9">
                      <img
                        :src="thumbnail(creator.user_name)"
                        :alt="creator.user_name"
                      />
                    </figure>
                  </div>
                  <div class="card-content">
                    <h3 class="heading">
                      <i class="fab fa-twitch" style="margin-right: 0.5rem"></i
                      >{{ creator.user_name }} -
                      {{ creator.viewer_count }} Viewers
                    </h3>
                    <h2 class="subtitle">{{ creator.title }}</h2>
                    <a
                      :href="twitchURL(creator.user_name)"
                      target="_blank"
                      class="button is-secondary is-small is-fullwidth"
                      >Watch</a
                    >
                  </div>
                </div>
              </div>
            </div>
            <div v-else class="column is-12 has-text-centered">
              <h2
                class="subtitle"
                style="color: #acacac; margin-top: 4rem; margin-bottom: 4rem"
              >
                Looks like no one is streaming right now. Check back later to
                see who comes online.
              </h2>
            </div>
          </transition>
        </div>
        <br /><br />
        <div class="twitch-feed gi-card">
          <b-loading
            class="youtubeLoading"
            :is-full-page="false"
            v-model="youtubeLoading"
            :can-cancel="false"
          ></b-loading>
          <h1 class="title">
            <i class="fab fa-youtube" style="margin-right: 1rem"></i>YouTube
            Feed
          </h1>
          <br />
          <div class="columns is-multiline">
            <div
              v-for="video in youtubeAPIResponses"
              :key="video.id"
              class="column is-3"
              data-aos="fade-up"
            >
              <div class="card video-item">
                <div class="card-image">
                  <figure class="image is-16by9">
                    <img
                      :src="video.snippet.thumbnails.medium.url"
                      :alt="video.snippet.title"
                    />
                  </figure>
                </div>
                <div class="card-content">
                  <h3 class="heading">
                    <i class="fab fa-youtube" style="margin-right: 0.5rem"></i
                    >{{ video.snippet.channelTitle }}
                  </h3>
                  <h2 class="subtitle">{{ video.snippet.title }}</h2>
                  <a
                    :href="ytLink(video.snippet.resourceId.videoId)"
                    target="_blank"
                    class="button is-secondary is-fullwidth"
                    >Watch</a
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Vue from "vue";
import VueTwitchPlayer from "vue-twitch-player";
import TwitchChat from "@/components/TwitchChat";
import BaseHero from "@/components/BaseHero";
export default {
  name: "Home",
  components: { VueTwitchPlayer, TwitchChat, BaseHero },
  data() {
    return {
      twitchLoading: true,
      youtubeLoading: true,
      channel: "theblackhokage",
      giData: [],
      twitchAPIResponses: [],
      youtubeAPIResponses: [],
      loadingStatus: {
        twitch: 0,
      },
    };
  },
  watch: {
    // whenever question changes, this function will run
    giData: function() {
      Promise.all(
        this.giYouTubeIDs.map((id) => {
          this.getYouTubeAPIData(id);
        })
      ).then(() => {
        this.youtubeLoading = false;
      });
      Promise.all(
        this.giTwitchIDs.map((id) => {
          this.getTwitchAPIData(id);
        })
      );
    },
    twitchAPIResponses: function() {
      this.initTwitch();
      this.twitchLoading = false;
    },
    youtubeAPIResponses: function() {
      this.youtubeLoading = false;
    },
  },
  mounted() {
    this.getAirTableData();
  },
  computed: {
    giYouTubeIDs: function() {
      let giData = this.giData;
      if (giData) {
        let ytIDs = [];
        giData.forEach((member) => {
          ytIDs.push(member.youtubeID);
        });
        return ytIDs;
      } else {
        return [];
      }
    },
    giTwitchIDs: function() {
      let giData = this.giData;
      if (giData) {
        let twIDs = [];
        giData.forEach((member) => {
          twIDs.push(member.twitchID);
        });
        return twIDs;
      } else {
        return [];
      }
    },
  },
  methods: {
    setStream(channel) {
      this.channel = channel;
    },
    async getAirTableData() {
      this.axios({
        url: "https://api.airtable.com/v0/appDFYQTsodbFxpmH/GI%20Members",
        headers: {
          Authorization: `Bearer ${process.env.VUE_APP_AIRTABLE_API_KEY}`,
        },
      })
        .then((res) => {
          let data = [];
          res.data.records.forEach((member) => {
            data.push(member.fields);
          });
          this.giData = data;
          return;
        })
        .catch(() => {
          return;
        });
    },
    async getTwitchAPIData(id) {
      this.twitchLoading = false;
      if (id == null) return;
      const gi = this.giData.length;
      if (this.loadingStatus.twitch < gi) {
        this.loadingStatus.twitch++;
        const url = `https://giupdates.tv/.netlify/functions/twitch?twitchID=${id}`;
        this.axios.get(url).then((res) => {
          console.log(res.data);
          if (res.data.live === false) return;
          const responseData = res.data.streamData;
          const curResultsArray = this.twitchAPIResponses;
          const newResultsArray = [...responseData, ...curResultsArray];
          this.twitchAPIResponses = newResultsArray;
          this.twitchLoading = false;
          return;
        });
      }
    },
    async getYouTubeAPIData(id) {
      this.youtubeLoading = false;
      if (id == null) return;
      const key = process.env.VUE_APP_YOUTUBE_API_KEY;
      const url = "https://www.googleapis.com/youtube/v3/playlistItems";
      const config = {
        params: {
          part: "snippet",
          maxResults: 4,
          playlistId: id,
          key: key,
        },
      };
      Vue.axios
        .get(url, config)
        .then((playlistData) => {
          const videos = playlistData.data.items;
          this.addToArray(videos);
          this.youtubeLoading = false;
          return;
        })
        .catch((err) => {
          console.log(err);
          return;
        });
    },

    initTwitch() {
      const data = this.twitchAPIResponses;
      this.twitchLoading = false;
      if (data.length > 0) this.setStream(data[0].user_name);
    },
    thumbnail(creator) {
      let lowercase = creator.toLowerCase();
      let url = `https://static-cdn.jtvnw.net/previews-ttv/live_user_${lowercase}-320x180.jpg`;
      return url;
    },
    ytLink(videoId) {
      const url = `https://www.youtube.com/watch?v=${videoId}`;
      return url;
    },
    twitchURL(username) {
      const url = `https://www.twitch.tv/${username}`;
      return url;
    },
    addToArray(videos) {
      for (var video of videos) {
        this.youtubeAPIResponses.push(video);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
$gi-card-border-radius: 0px;
$yt-card-border-radius: 0px;

@media only screen and (max-width: 43.75em) {
  .content-wrapper {
    padding: 0.5rem;
  }
}
.content-wrapper {
  min-height: 50rem;
}
.gi-card {
  background: #0d0c10;
  border: 2px solid darken($color: #bf9c5a, $amount: 20);
  border-top-left-radius: 20px;
  border-bottom-right-radius: 20px;
  padding: 1.5rem;
  text-align: left;
  // box-shadow: #9e8425 0px 1px 2px;
  h1,
  h2 {
    color: #bf9c5a;
    background: -webkit-linear-gradient(250deg, #d5be78 30%, #a87839 60%);
    background-clip: text;
  }
}
.offset {
  margin-top: -5rem;
}
.stream-card {
  padding: 1rem;
  h2 {
    font-weight: 700;
    font-size: 1.25rem;
    span {
      margin-left: 0.5rem;
      font-size: 0.6rem;
      text-transform: uppercase;
      letter-spacing: 0.1rem;
    }
  }
}

iframe {
  border-top-right-radius: 8px !important;
  border-bottom-right-radius: 0px !important;
  overflow: hidden !important;
}
#twitch-player {
  border-top-left-radius: 8px !important;
  border-bottom-left-radius: 8px !important;
  overflow: hidden !important;
}
.twitch-player-wrapper {
  min-height: 500px;
}
.card {
  background: #01010c;
  border-top-left-radius: 10px;
  border-bottom-right-radius: 10px;
  border: 1px solid darken($color: #bf9c5a, $amount: 30);
  transition: all 1s ease-out;
  &:hover {
    .subtitle {
      color: ghostwhite;
    }
  }
  img {
    border-top-left-radius: 10px;
  }
  .heading {
    color: #bf9c5a;
  }
  .subtitle {
    color: #acacac;
    font-size: 1.1rem;
  }
}
</style>
